import { Link, useLocation } from "react-router-dom";
import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useApi } from "../../middleware/middleware";
import logo from "../../assets/img/logo-3.png";
import { ArrowDropDown } from "@material-ui/icons";
import "./Topbar3.css";
// Make sure to import this CSS file that contains the dropdown styles

function Topbar4() {
  const { data, error, isLoading } = useApi("services_list", {});
  const [hoveredMenu, setHoveredMenu] = useState(null);
  const [activeMenu, setActiveMenu] = useState(null); // State to track the active menu
  const history = useHistory();
  const location = useLocation(); // Get current location to highlight active link
  const dropdownRefs = useRef({});

  const {
    data: location2,
    error: locationError,
    isLoading: locationLoading,
  } = useApi("get_ip_details", {});

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (hoveredMenu && !event.target.closest('.menu-item')) {
        setHoveredMenu(null);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [hoveredMenu]);

  const handleServiceClick = (service) => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}services_list_detail?service_id=${service.associations_and_partners__ID}`
      )
      .then((response) => {
        const responseData = response.data;
        if (responseData.success && responseData.data.length > 0) {
          const serviceDetail = responseData.data[0];
          const formattedName =
            serviceDetail.associations_and_partners__Name.replace(/ /g, "_");
          history.push({
            pathname: `/services/${formattedName}`,
            state: {
              item: serviceDetail.associations_and_partners__Description,
              heading: serviceDetail.associations_and_partners__Name,
              category: serviceDetail.cat_name,
            },
          });
        } else {
          console.error("No data found for service:", service);
        }
      })
      .catch((error) => {
        console.error("Error fetching service details:", error);
      });
  };

  // Function to check if the current route is active
  const isActiveLink = (path) => location.pathname === path;

  // Function to handle dropdown toggle
  const toggleDropdown = (menu) => {
    setHoveredMenu(hoveredMenu === menu ? null : menu);
  };

  return (
    <header className="desktop-menu header-wrap header-5">
      <div className="container">
        <div className="row align-items-center justify-content-between">
          <div className="col-lg-12 pl-lg-3 header-none">
            <div className="main-menu">
              <ul>
               
                <li
                  className={`menu-item ${
                    hoveredMenu === "products" || isActiveLink("/product-by-category")
                      ? "active-menu"
                      : ""
                  }`}
                >
                  <Link
                    to="/product-by-category"
                    className={isActiveLink("/product-by-category") ? "active" : ""}
                  >
                    Products
                  </Link>
                </li>

                <li
                  className={`menu-item ${
                    hoveredMenu === "standard" || isActiveLink("/product-by-standards")
                      ? "active-menu"
                      : ""
                  }`}
                >
                  <Link
                    to="/product-by-standards"
                    className={isActiveLink("/product-by-standards") ? "active" : ""}
                  >
                    Test Method
                  </Link>
                </li>

                <li
                  className={`menu-item ${
                    hoveredMenu === "equipment" || isActiveLink("/equipment-category")
                      ? "active-menu"
                      : ""
                  }`}
                >
                  <Link
                    to="/equipment-category"
                    className={isActiveLink("/equipment-category") ? "active" : ""}
                  >
                    Equipment
                  </Link>
                </li>

                <li
                  className={`menu-item ${
                    hoveredMenu === "services" || isActiveLink("/services")
                      ? "active-menu"
                      : ""
                  }`}
                >
                  <Link
                    to="/services"
                    className={isActiveLink("/services") ? "active" : ""}
                  >
                    Services
                  </Link>
                </li>

                {/* Support with Dropdown */}
                <li
                  ref={(el) => (dropdownRefs.current.support = el)}
                  onMouseEnter={() => setHoveredMenu("support")}
                  onMouseLeave={() => setHoveredMenu(null)}
                  className={`menu-item dropdown ${
                    hoveredMenu === "support" || 
                    isActiveLink("/support") || 
                    isActiveLink("/product-verification") ||
                    isActiveLink("/download-app")
                      ? "active-menu"
                      : ""
                  }`}
                >
                  <div 
                    className="dropdown-toggle"
                    onClick={() => toggleDropdown("support")}
                  >
                    <Link
                      to="/support"
                      className={isActiveLink("/support") ? "active" : ""}
                      // onClick={(e) => e.preventDefault()}
                    >
                      Support
                    </Link>
                    {/* <ArrowDropDown /> */}
                  </div>
                  
                  <div className="dropdown-menu" style={{ 
                      display: hoveredMenu === "support" ? "block" : "none" 
                    }}>
                      {/* <Link to="/support">Support Home</Link> */}
                      <Link to="/product-verification">Verification</Link>
                      <Link to="/download-app">QR Code / Download App</Link>
                    </div>
                </li>

                {/* About Us */}
                <li
                  className={`menu-item ${
                    hoveredMenu === "about" || isActiveLink("/heritage")
                      ? "active-menu"
                      : ""
                  }`}
                >
                  <Link
                    to="/heritage"
                    className={isActiveLink("/heritage") ? "active" : ""}
                  >
                    About Us
                  </Link>
                </li>
                <li
                  className={`menu-item ${
                    hoveredMenu === "contact" || isActiveLink("/choose-region")
                      ? "active-menu"
                      : ""
                  }`}
                >
                  <Link
                      to={`/choose-region/${location2?.country}`}
                      className={isActiveLink(`/choose-region/${location2?.country}`) ? "active" : ""}
            
                    >
                      Contact Us
                    </Link>
                </li>
                <li
                  className={`menu-item ${
                    hoveredMenu === "order" || isActiveLink("/place-order")
                      ? "active-menu"
                      : ""
                  }`}
                >
                  <Link
                      to={`/place-order`}
                      className={isActiveLink(`/place-order`) ? "active" : ""}
                      style={{textTransform: "none"}}
                    >
                      Place an Order
                    </Link>
                </li>

                {/* Contact Us with Dropdown */}
                {/* <li
                  ref={(el) => (dropdownRefs.current.contact = el)}
                  onMouseEnter={() => setHoveredMenu("contact")}
                  onMouseLeave={() => setHoveredMenu(null)}
                  className={`menu-item dropdown ${
                    hoveredMenu === "contact" || 
                    isActiveLink("/choose-region") ||
                    isActiveLink("/international-representation")
                      ? "active-menu"
                      : ""
                  }`}
                >
                  <div 
                    className="dropdown-toggle"
                    onClick={() => toggleDropdown("contact")}
                  >
                    <Link
                      to={`/choose-region/${location2?.country}`}
                      className={isActiveLink(`/choose-region/${location2?.country}`) ? "active" : ""}
                      onClick={(e) => e.preventDefault()}
                    >
                      Contact Us
                    </Link>
                  </div>
                  
                  <div className="dropdown-menu" style={{ 
                      display: hoveredMenu === "contact" ? "block" : "none" 
                    }}>
                      <Link to={`/choose-region/${location2?.country}`}>Contact Us</Link>
                      <Link to="/international-representation">International Representation</Link>
                    </div>
                </li> */}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Topbar4;


//  <li
//                   ref={(el) => (dropdownRefs.current.banner = el)}
//                   onMouseEnter={() => setHoveredMenu("banner")}
//                   onMouseLeave={() => setHoveredMenu(null)}
//                   className={`menu-item dropdown ${
//                     hoveredMenu === "banner" || 
//                     isActiveLink("/innovation") || 
//                     isActiveLink("/application") ||
//                     isActiveLink("/heritage")
//                       ? "active-menu"
//                       : ""
//                   }`}
//                 >
//                   <div 
//                     className="dropdown-toggle"
//                     onClick={() => toggleDropdown("banner")}
//                   >
//                     <Link
//                       to="/"
//                       className={isActiveLink("/banner") ? "active" : ""}
//                       onClick={(e) => e.preventDefault()}
//                     >
//                       Banners
//                     </Link>
//                     {/* <ArrowDropDown /> */}
//                   </div>
                  
//                   <div className="dropdown-menu" style={{ 
//                       display: hoveredMenu === "banner" ? "block" : "none" 
//                     }}>
//                       <Link to="/innovation">Innovation</Link>
//                       <Link to="/application">Application</Link>
//                       <Link to="/heritage">Legacy</Link>
//                     </div>
//                 </li>